import { useState } from "react";

export default function ResetPasswordModal({ open, onClose, onSubmit, email }) {
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    onSubmit({
      email,
      otp,
      newPassword,
      confirmPassword
    });
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg w-[400px] shadow-lg">
        
        <h2 className="text-xl font-semibold mb-4">Reset Password</h2>

        <div className="space-y-3">
          <div>
            <label className="text-sm">OTP</label>
            <input
              className="w-full border px-3 py-2 rounded"
              value={otp}
              onChange={e => setOtp(e.target.value)}
            />
          </div>

          <div>
            <label className="text-sm">New Password</label>
            <input
              type="password"
              className="w-full border px-3 py-2 rounded"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
            />
          </div>

          <div>
            <label className="text-sm">Confirm Password</label>
            <input
              type="password"
              className="w-full border px-3 py-2 rounded"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-4">
          <button className="px-4 py-2 bg-gray-200 rounded" onClick={onClose}>
            Cancel
          </button>

          <button
            className="px-4 py-2 bg-blue-600 text-white rounded"
            onClick={handleSubmit}
          >
            Reset Password
          </button>
        </div>
      </div>
    </div>
  );
}
